export enum EnumApiShow {
  showDetail = '/show/api/shows/{showId}',
  appletsQrcode = '/show/api/show/share/applets/qrcode',
  randomWorks = '/show/api/show/random/awards'
}
